import 'reflect-metadata';
import { inject, injectable } from 'inversify';
import { arsenal_unit, arsenal_unit_dto } from '@Api';
import { ArsenalUnit } from '@Models';
import { ArsenalStepMapper } from '@Mapper/arsenal/arsenal-step.mapper';
import { TYPES } from '@Types';

@injectable()
export class ArsenalUnitMapper {
  @inject(TYPES.Mapper.ArsenalStepMapper)
  private _arsenalStepMapper!: ArsenalStepMapper;

  public map(item: arsenal_unit): ArsenalUnit {
    return {
      id: item.id,
      name: item.name,
      unitCategoryId: item.unit_category_id,
      mountCategoryId: item.mount_category_id,
      comment: item.comment,
      position: item.position,
      unitIds: item.unit_ids,
      steps: item.steps.map((step) => this._arsenalStepMapper.map(step)),
    } satisfies ArsenalUnit as ArsenalUnit;
  }

  public mapDto(item: ArsenalUnit): arsenal_unit_dto {
    return {
      id: item.id,
      name: item.name,
      unit_category_id: item.unitCategoryId,
      mount_category_id: item.mountCategoryId,
      comment: item.comment,
      position: item.position,
      steps_attributes: item.steps.map((step) =>
        this._arsenalStepMapper.mapDto(step),
      ),
    } satisfies arsenal_unit_dto as arsenal_unit_dto;
  }
}
